import { HashRouter as Router, Route, Routes } from 'react-router-dom'
import { Accessibility } from "./pages/accessibility"
import { DeleteAccount } from "./pages/delete-account"
import { PrivacyPolicy } from "./pages/privacy-policy"
import { Download } from "./pages/download"

function App() {

  return <Router>
    <Routes>
      <Route path='/delete-account' element={<DeleteAccount />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/accessibility' element={<Accessibility />} />
      <Route path='/' element={<Download />} />
    </Routes>
  </Router>
}

export default App